import type theme from '#build/ui/calendar'
import type { DeepPartial } from '@nuxt/ui'

const calendar: DeepPartial<typeof theme> = {
  slots: {
    root: '',
    header: 'flex items-center justify-between',
    body: 'flex flex-col space-y-4 pt-4 sm:flex-row sm:space-x-4 sm:space-y-0',
    heading: 'mx-auto truncate text-center font-medium',
    grid: 'focus:outline-hidden w-full border-collapse select-none space-y-1',
    gridRow: 'grid grid-cols-7',
    gridWeekDaysRow: 'mb-1 grid w-full grid-cols-7',
    gridBody: 'grid',
    headCell: 'rounded-lg font-bold',
    cell: 'relative text-center',
    cellTrigger: 'transitions-normal focus:outline-hidden data-disabled:text-cvt-cloud-700 data-unavailable:text-cvt-cloud-800 relative m-0.5 flex items-center justify-center whitespace-nowrap rounded-md focus-visible:ring-2 data-unavailable:pointer-events-none data-today:font-bold data-selected:text-white data-unavailable:line-through',
  },
  variants: {
    color: {
      neutral: {
        headCell: 'text-cvt-text-dark',
        cellTrigger: 'focus-visible:ring-cvt-purple-600 data-[highlighted]:bg-cvt-purple-600 data-[selected]:bg-cvt-purple-600 hover:not-data-[selected]:bg-cvt-purple-200 data-today:not-data-[selected]:text-cvt-purple-600',
      },
      error: {
        headCell: 'text-cvt-burgundy-600',
        cellTrigger: 'focus-visible:ring-cvt-burgundy-600 data-[highlighted]:bg-cvt-burgundy-600 data-[selected]:bg-cvt-burgundy-600 hover:not-data-[selected]:bg-cvt-burgundy-200 data-today:not-data-[selected]:text-cvt-burgundy-600',
      },
    },
    size: {
      xs: {
        heading: 'text-xs',
        cell: 'text-xs',
        headCell: 'text-[10px]',
        cellTrigger: 'size-7',
        body: 'space-y-2 pt-2',
      },
      sm: {
        heading: 'text-xs',
        headCell: 'text-xs',
        cell: 'text-xs',
        cellTrigger: 'size-7',
      },
      md: {
        heading: 'text-sm',
        headCell: 'text-xs',
        cell: 'text-sm',
        cellTrigger: 'size-8',
      },
      lg: {
        heading: 'text-md',
        headCell: 'text-md',
        cellTrigger: 'text-md size-9',
      },
      xl: {
        heading: 'text-lg',
        headCell: 'text-lg',
        cellTrigger: 'size-10 text-lg',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'neutral',
  },
}

export default calendar
